import React, { useEffect, useState } from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/templated-option-button/templated-option-button-head.css';

const valuesShape = PropTypes.shape({
  text: PropTypes.string,
  value: PropTypes.any,
});

const StandardDropDownList = React.memo(({
  displayOptions,
  onClick,
}) => {
  const [displayValue, setDisplayValue] = useState(displayOptions);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    setDisplayValue(displayValue);
  }, [displayValue]);

  const searchHandler = (event) => {
    // Search func for filter array by searching any related text keywords
    const searchQuery = event.toLowerCase();
    const displayedValue = displayOptions.filter((el) => {
      const searchValue = el.text.toLowerCase().includes(searchQuery);
      return searchValue;
    });

    setDisplayValue(displayedValue);
    setSearchInput(event);
  };

  return (
    <>
      { // Search div when default array length > 5
        displayOptions.length > 5 && (
          <div className="search-drop">
            <input
              className="Search-Input"
              type="text"
              onChange={(e) => searchHandler(e.target.value)}
              placeholder=" Please Search Here..."
              value={searchInput}
            />
            <div className={`no-result-msg ${displayValue.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
          </div>
        )
      }
      {
        displayValue.map((options, i) => {
          const {
            text,
            value,
          } = options;
          return (
            <li
              key={value}
              className="dropdown-item"
            >
              <div className="template-option template-option-standard">
                <OptionButton
                  onClick={onClick}
                  option={value}
                >
                  <p>{text}</p>
                </OptionButton>
              </div>
            </li>
          );
        })
      }
    </>
  );
});

StandardDropDownList.propTypes = {
  displayOptions: PropTypes.arrayOf(valuesShape),
  onClick: PropTypes.func,
};

export { StandardDropDownList };

